"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.areObjectValuesEmpty = exports.modifyObjectValues = exports.combineApartmentsData = exports.findFirstDuplicateIndex = exports.pickWithDefaults = void 0;
var fromPairs_1 = __importDefault(require("lodash/fromPairs"));
var toPairs_1 = __importDefault(require("lodash/toPairs"));
var uniqueId_1 = __importDefault(require("lodash/uniqueId"));
var isPlainObject_1 = __importDefault(require("lodash/isPlainObject"));
var pickWithDefaults = function (o, picks) {
    var keys = Object.keys(picks);
    var obj = o || {};
    return keys.reduce(function (acc, key) {
        var _a;
        var value = obj[key];
        var defaultVal = picks[key];
        if (isPlainObject_1.default(defaultVal)) {
            defaultVal = exports.pickWithDefaults(value, picks[key]);
        }
        return Object.assign(acc, (_a = {},
            _a[key] = value || defaultVal,
            _a));
    }, {});
};
exports.pickWithDefaults = pickWithDefaults;
var findFirstDuplicateIndex = function (arr, mapper) {
    if (mapper === void 0) { mapper = function (v) { return v; }; }
    var values = arr.map(mapper);
    for (var i = 0; i < values.length; i++) {
        for (var j = 0; j < values.length; j++) {
            // Skip self comparison
            if (i !== j) {
                // Check for duplicate
                if (values[i] === values[j]) {
                    return j;
                }
            }
        }
    }
    return -1;
};
exports.findFirstDuplicateIndex = findFirstDuplicateIndex;
var combineApartmentsData = function (_a) {
    var apt_number = _a.apt_number, price = _a.price, currency = _a.currency;
    return {
        key: uniqueId_1.default(),
        text: apt_number,
        value: apt_number,
        price: [{ price: price, currency: currency }],
    };
};
exports.combineApartmentsData = combineApartmentsData;
var modifyObjectValues = function (obj, ent) {
    return fromPairs_1.default(toPairs_1.default(obj).map(function (_a) {
        var key = _a[0], value = _a[1];
        return [key, (value = ent)];
    }));
};
exports.modifyObjectValues = modifyObjectValues;
var areObjectValuesEmpty = function (obj) {
    for (var _i = 0, _a = Object.keys(obj); _i < _a.length; _i++) {
        var key = _a[_i];
        var value = obj[key];
        if ((Array.isArray(value) && value.length !== 0) ||
            (typeof value === 'string' && value.trim() !== '')) {
            return true;
        }
    }
    return false;
};
exports.areObjectValuesEmpty = areObjectValuesEmpty;
